export default __webpack_public_path__ + "static/Entenda0115-f6d3e4ee8fe02e1c3f5b992b008abcad.jpg";